<template>
  <div style="padding: 0px 24px;">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="门店">
        <el-select v-model="formInline.md" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>   
      </el-form-item>
      <el-form-item label="开始年月">
        <el-date-picker type="date" placeholder="选择日期" v-model="formInline.ksny"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束年月">
        <el-date-picker type="date" placeholder="选择日期" v-model="formInline.jsny"></el-date-picker>
      </el-form-item>
      <el-form-item label="合同号">
        <el-input v-model="formInline.hth"></el-input>
      </el-form-item>
      <el-form-item label="品牌">
        <el-input v-model="formInline.pp"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" class="chaxun">查询</el-button>
        <el-button type="warning" @click="print_all" class="chaxun">批量打印费用结算单</el-button>
        <!-- <el-button type="warning" @click="getList" class="chaxun">重置</el-button> -->
      </el-form-item>
    </el-form>
    <!-- <el-table :data="tableData" :height="conheight" style="width: 100% !important;border-top: 1px solid #000 !important;border-left: 1px solid #000 !important;"> -->
    <el-table :data="tableData" :height="conheight" style="width: 100% !important;" border>
      <el-table-column label="序号" width="50"><template slot-scope="scope">{{scope.$index+1}}</template></el-table-column>
      <el-table-column prop="FDMC" label="门店" width="100"></el-table-column>
      <el-table-column prop="JSPZ" label="结算凭据" width="60"></el-table-column>
      <el-table-column prop="NY" label="月结" width="60"></el-table-column>
      <el-table-column prop="HTH" label="合同号" width="80"></el-table-column>
      <el-table-column prop="SHMC" label="商户名称"></el-table-column>
      <el-table-column prop="PP" label="品牌"></el-table-column>
      <el-table-column prop="DHF" label="电汇费" width="80"></el-table-column>
      <el-table-column prop="TM_CDF" label="场地特卖费" width="80"></el-table-column>
      <el-table-column prop="QT" label="其他" width="80"></el-table-column>
      <el-table-column prop="WYBZJ" label="履约保证金" width="80"></el-table-column>
      <el-table-column prop="SDBZJ" label="水电保证金" width="80"></el-table-column>
      <el-table-column prop="SYXT_YJ" label="收银系统押金" width="80"></el-table-column>
      <el-table-column prop="QTYJ" label="其他押金" width="80"></el-table-column>
      <el-table-column prop="ZG_ZSXJK" label="减：专柜自收现金营业款" width="80"></el-table-column>
      <el-table-column prop="WS_DSXJ" label="我司代收现金部分" width="80"></el-table-column>
      <el-table-column prop="YSXJ" label="已收现金费用" width="80"></el-table-column>
      <el-table-column prop="GYSHK" label="应付供应商货款" width="80"></el-table-column>
      <el-table-column label="操作" width="140">
        <template slot-scope="scope">
          <span class="menuname"><el-link icon="el-icon-download" @click="print(scope.row)">打印费用结算单</el-link></span>
          <span class="menuname">
            <el-link icon="el-icon-download" @click="OpenDialog(scope.row)">查看发票</el-link>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer title="发票明细" :visible.sync="dialogTableVisible"  direction="rtl"  size="50%">
      <el-table :data="gridData" :height="conheight" border>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">{{scope.$index+1}}</template>
        </el-table-column>
        <el-table-column property="f_pp" label="品牌"></el-table-column>
        <el-table-column property="f_kpny" label="开票年月"></el-table-column>
        <el-table-column property="f_fyxm" label="费用项目"></el-table-column>
        <el-table-column property="f_fyje" label="费用金额"></el-table-column>
        <el-table-column property="f_pdfwj" label="发票文件">
          <template slot-scope="scope">
            <span class="menuname">
              <el-link icon="el-icon-position" @click="download_item(scope.row)">在线查看</el-link><br/>
              <el-link icon="el-icon-download" @click="download(scope.row,'PDF')">下载PDF发票</el-link><br/>
              <el-link icon="el-icon-download" @click="download(scope.row,'XML')">下载XML发票</el-link><br/>
              <el-link icon="el-icon-download" @click="download(scope.row,'OFD')">下载OFD发票</el-link><br/>
            </span>
            </template>
        </el-table-column>
      </el-table>
    </el-drawer>
  </div>
</template>

<script>

export default {
  components: {
  },
  name: "zlfymxd",
  data() {
    return {
      options: [{value: '海雅百货南山店',label: '海雅百货南山店'}, 
      {value: '海雅百货东莞东城店',label: '海雅百货东莞东城店'},
      // {value: '海雅百货东莞南城店',label: '海雅百货东莞南城店'},
      {value: '海雅缤纷城购物中心',label: '海雅缤纷城购物中心'},
      {value: '中山海雅缤纷天地',label: '中山海雅缤纷天地'}],
      tableData:[],
      formInline: {
        md:'',
        ksny:'',
        jsny:'',
        hth:'',
        pp:''
      },
      user:JSON.parse(sessionStorage.currentUser),
      conheight: window.innerHeight-136,
      dialogTableVisible: false,
      gridData: []
    };
  },
  methods: {
    download_item(row){//下载发票
      let url = row.f_pdfwj;
      let token = "testtoken";
      let idocvUrl = "http://10.10.10.74:8168";
      //***** 外网 *****/
      if(window.location.origin.indexOf("http://61.144.170.91")>-1){//副线环境
        idocvUrl = "http://61.144.170.91:8168";
      }
      if(window.location.origin.indexOf("http://zs.haiya.com.cn")>-1){//副线环境
        idocvUrl = "http://61.144.170.91:8168";
      }
      window.app.$http.post(idocvUrl+'/doc/upload?token='+token+'&url='+url).then((resp) => {
        window.open(idocvUrl+"/view/"+resp.data.uuid,"_blank","width=" +(window.screen.availWidth/2) +",height=" +(window.screen.availHeight/2));
      });
    },
    download(row,type){//下载发票
      if(type=='PDF'){
        window.open(row.f_pdfwj);
      }
      if(type=='XML'){
        window.open(row.f_xmlwj);
      }
      if(type=='OFD'){
        window.open(row.f_ofdwj);
      }
    },
    OpenDialog(row){
      this.gridData = [];
      let param = {
          "ghdwdm":row.WLDW,
          "kpny":Number(row.NY),
          "hth":row.HTH
      }
      window.app.$http.post(context.bpmRunTime+"/bpm/haiyaapi/getKpmxqk",param).then(resp=>{
        if(resp.data.code==500){
          this.$notify.error({
            title: "未查到本月对应发票，请等待商场方完成开票后下载。",
            duration: 2000
          });
        }else{
          this.gridData = resp.data.data;
          this.dialogTableVisible=true;//打开弹出层
        }
      })
    },
    print_all(){
      window.open("/fvue/print_zlfymxd_all","_blank","width=" + (window.screen.availWidth - 10) +",height=" +(window.screen.availHeight - 70) );
    },
    print(row){//打印
        window.open("/fvue/print_zlfymxd?HTH="+row.HTH+"&NY="+row.NY,"_blank","width=" + (window.screen.availWidth - 10) +",height=" +(window.screen.availHeight - 70) );
    },
    getDate(currentDate){
      const year = currentDate.getFullYear();
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const day = String(currentDate.getDate()).padStart(2, '0');
      const formattedDate = year+month;
      return formattedDate;
    },
    onSubmit() {
      this.tableData = [];
      let sql = "";
      if(this.user.username=='付婉婷'){//查看全部
        sql += "select * from V_ZSPT_ZLJFD where 1=1 ";
      }else{
        sql += "select * from V_ZSPT_ZLJFD where (WLDW='"+this.user.account.replaceAll("SZHY","")+"' or kj=(select fullname_ from uc_user where id_='"+this.user.userId+"')) ";
      }
      if(this.formInline.md.length>0){
        sql += " and instr(FDMC,'"+this.formInline.md+"',1,1)>0";
      }
      if(this.formInline.ksny!=null && this.formInline.ksny!='' && this.formInline.jsny!=null && this.formInline.jsny!=''){
        sql += " and NY BETWEEN '"+this.getDate(this.formInline.ksny)+"' and '"+this.getDate(this.formInline.jsny)+"'";
      }
      // else{
      //   sql += " and NY = to_char(sysdate,'yyyymm')";
      // }
      if(this.formInline.hth.length>0){
        sql += " and instr(HTH,'"+this.formInline.hth+"',1,1)>0";
      }
      if(this.formInline.pp.length>0){
        sql += " and instr(PP,'"+this.formInline.pp+"',1,1)>0";
      }
      this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
          this.tableData = resp.data.result;
          sessionStorage.setItem("zlsql",sql);
        }
      });
    },
    getList(){
      let sql = "select * from V_ZSPT_ZLJFD WHERE NY BETWEEN to_char(add_months(sysdate,-2),'yyyymm') and to_char(add_months(sysdate,+1),'yyyymm')  ";
      if(this.user.username=='付婉婷'){//查看全部
      }else{
       sql += "and (WLDW='"+this.user.account.replaceAll("SZHY","")+"' or kj=(select fullname_ from uc_user where id_='"+this.user.userId+"'))";
      }
      this.$http.get(context.bpmRunTime+"/bpm/haiyaScript/executeSql?param="+Base64.encode(sql)).then(resp=>{
        if(resp.data.result.length>0){
          this.tableData = resp.data.result;
          sessionStorage.setItem("zlsql",sql);
        }
      });
    },
  },
  mounted(){
    this.getList();
    let currentDate = new Date(); // 获取当前日期和时间
    currentDate.setMonth(currentDate.getMonth() - 2); // 将月份减去1
    this.formInline.ksny=currentDate;

    let currentDate1 = new Date(); // 获取当前日期和时间
    currentDate1.setMonth(currentDate1.getMonth() + 1); // 将月份减去1
    this.formInline.jsny=currentDate1;
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .el-table .cell{
  padding: 0px !important;
  text-align: center !important;
}
/deep/ .el-table th{
  // border-right:1px solid #000 !important;
  // border-bottom:1px solid #000 !important;
  .cell{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #292B44;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}
/deep/ .el-table td{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #292B44;
    line-height: 22px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  // border-right:1px solid #000 !important;
  // border-bottom:1px solid #000 !important;
}
/deep/ .el-form-item--small .el-form-item__label{
  line-height: 48px !important;
  height: 48px !important;
  color: #292B44 !important;
  font-size: 14px;
}
/deep/ .el-form-item--small .el-form-item__content{
  line-height: 48px !important;
  height: 48px !important;
}
/deep/ .el-form-item el-form-item--small{
  margin: 0px !important;
  line-height: 48px !important;
  height: 48px !important;
}
/deep/ .el-form-item--small.el-form-item{
  margin: 0px !important;
  line-height: 48px !important;
  height: 48px !important;
  padding-right: 32px !important;
}
/deep/ .demo-form-inline{
  // height: 48px !important;
  // line-height: 48px !important;
  padding: 8px 0px !important;
}
/deep/ .chaxun{
  span{
    font-size:14px !important;
  }
}
</style>